module.exports = __webpack_public_path__ + "img/menu_arrow.40867c08.svg";